import React, { useEffect, useState, useContext } from "react";
import { FormContext } from "../context/FormContext";
import "bootstrap/dist/css/bootstrap.min.css";
import examenVisual from "../assets/images/ico_gmo2.png";
import ico4 from "../assets/images/ico_gmo4.png";

const ServicioItem = ({ titulo, descripcion, id, imgSrc }) => {
  return (
    <div className="accordion-item">
      <h2 className="accordion-header" id={`heading${id}`}>
        <p
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#collapse${id}`}
          aria-expanded="false"
          aria-controls={`collapse${id}`}
        >
          {titulo}
          <img className="img-side-step me-2" src={imgSrc} alt={titulo} />
        </p>
      </h2>
      <div
        id={`collapse${id}`}
        className="accordion-collapse collapse"
        aria-labelledby={`heading${id}`}
        data-bs-parent="#serviciosAccordion"
      >
        <div className="accordion-body">
          {/* Utilizamos dangerouslySetInnerHTML para interpretar el HTML */}
          <p dangerouslySetInnerHTML={{ __html: descripcion }} />
        </div>
      </div>
    </div>
  );
};

const Servicios = () => {
  const { formData } = useContext(FormContext);
  const [rowClass, setRowClass] = useState("row bg-white");

  useEffect(() => {
    const bookingElement = document.querySelector("#booking");
    if (bookingElement) {
      setRowClass("row bg-white topbot20");
    }
  }, []);

  const examenVisualNinosDescripcion = {
    // Descripciones por país
    cl: "Asegura la salud visual de tu hijo con un examen visual realizado por nuestros especialistas en optometría. Recuerda que siempre debe venir acompañado con un adulto.",
    co: "Asegura la salud visual de tu hijo con un examen visual realizado por nuestros especialistas. Este examen está diseñado especialmente para niños. <br><b>*Aplica desde los 3 años</b>",
    ec: "Asegura la salud visual de tu hijo con un examen visual realizado por nuestros especialistas. Este examen está diseñado especialmente para niños. <br><b>*Aplica desde los 12 años</b>",
    pe: "Asegura la salud visual de tu hijo con un examen visual realizado por nuestros especialistas. Este examen está diseñado especialmente para niños. <br><b>*Aplica desde los 12 años</b>",
  };

  const renderServicios = () => {
    // Verificamos si 'formData' y 'formData.pais' existen antes de continuar
    const pais = formData?.pais;
    const cadena = formData?.cadena;

    switch (cadena) {
      case "gmo":
        return (
          <>
            {(pais === "ec" || pais === "pe") ? (
              <ServicioItem
                id="1"
                titulo="Examen visual (optómetra)"
                descripcion="Cuida tu salud visual con un examen a la vista integral realizado por nuestros expertos optometristas. Evaluamos tu agudeza visual, determinamos la receta perfecta para tus lentes."
                imgSrc={examenVisual}
              />
            ) : (
              <ServicioItem
                id="1"
                titulo="Examen visual (tecnólogo médico)"
                descripcion="Cuida tu salud visual con un examen a la vista integral realizado por nuestros expertos optometristas. Evaluamos tu agudeza visual, determinamos la receta perfecta para tus anteojos."
                imgSrc={examenVisual}
              />
            )}
            {/* Condición para Chile: Ocultar examen visual para niños */}
            {(pais === "ec" || pais === "pe") ? (
              <ServicioItem
                id="3"
                titulo="Examen visual (optómetra) para niños"
                descripcion={examenVisualNinosDescripcion[pais] || examenVisualNinosDescripcion["cl"]}
                imgSrc={examenVisual}
              />
            ) : (pais === "co") ? (
              <ServicioItem
                id="3"
                titulo="Examen visual (tecnólogo médico) para niños"
                descripcion={examenVisualNinosDescripcion[pais] || examenVisualNinosDescripcion["cl"]}
                imgSrc={examenVisual}
              />
            ) : null}
            {pais !== 'ec' && (
              <ServicioItem
                id="2"
                titulo="Contactología"
                descripcion="Descubre la comodidad y la claridad de visión que ofrecen los lentes de contacto con un examen de contactología realizado por nuestros especialistas. Evaluamos tu salud visual, medimos la curvatura de tus ojos y determinamos el tipo de lente ideal para ti. Además, te enseñamos cómo colocarlos y cuidarlos correctamente."
                imgSrc={ico4}
              />
            )}
          </>
        );

      case "opv":
        return (
          <>
            <ServicioItem
              id="4"
              titulo="Examen visual (tecnólogo medico)"
              descripcion="Cuida tu salud ocular con un examen visual integral realizado por nuestros expertos optometristas. Evaluamos tu agudeza visual, determinamos la receta perfecta para tus anteojos."
              imgSrc={examenVisual}
            />
            <ServicioItem
              id="5"
              titulo="Contactología"
              descripcion="Descubre la comodidad y la claridad de visión que ofrecen los lentes de contacto con un examen de contactología realizado por nuestros especialistas. Evaluamos tu salud ocular, medimos la curvatura de tus ojos y determinamos el tipo de lente ideal para ti. Además, te enseñamos cómo colocarlos y cuidarlos correctamente."
              imgSrc={ico4}
            />
          </>
        );

      case "eco":
        return (
          <>
            <ServicioItem
              id="6"
              titulo="Examen visual (tecnólogo medico)"
              descripcion="Cuida tus ojos con un examen visual completo hecho por nuestros expertos optometristas. Evaluamos tu visión con precisión y te damos la receta perfecta para tus lentes, asegurando que veas de maravilla."
              imgSrc={examenVisual}
            />
            <ServicioItem
              id="7"
              titulo="Contactología"
              descripcion="Descubre lo cómodos que pueden ser los lentes de contacto con un examen hecho por nuestros expertos. Medimos la curvatura de tus ojos, elegimos el tipo de lente ideal para ti y te damos una capacitación personalizada sobre cómo ponerlos y cuidarlos."
              imgSrc={ico4}
            />
          </>
        );

      default:
        return <></>;
    }
  };

  return (
    <div className={rowClass}>
      <div className="col-12 mb10">
        <p className="mb0 text-md-start text-center upper">
          <b>CONOCE TODOS LOS SERVICIOS DISPONIBLES QUE TENEMOS PARA TI:</b>
        </p>
      </div>
      <div className="col-12 pads0-768">
        <div className="accordion" id="serviciosAccordion">
          {renderServicios()}
        </div>
      </div>
    </div>
  );
};

export default Servicios;
